import { Injectable } from "@angular/core";
import { AbstractAdapter, Adapter, IAdapter } from "@app/utils/types";
import { ISupply, Supply } from "@app/models/supply.model";

@Injectable({
  providedIn: "root",
})
@Adapter({ classRef: Supply })
export class SupplyAdapter
  extends AbstractAdapter<ISupply, Supply>
  implements IAdapter<ISupply, Supply> {}
